
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ButtonPrimary',
  props: {
    label: {
      type: String,
      required: true,
      note: 'Label for the button'
    },
    outline: {
      type: Boolean,
      required: false,
      default: false
    },
    disable: {
      type: Boolean,
      required: false,
      default: false
    },
    color: {
      type: String,
      required: false,
      default: 'primary'
    }
  }
});
